import Image from 'next/image';

import loaderImg from '@/assets/images/logo-loader.gif';
import cn from '@/helpers/utils/classNames';

const Loader: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <div
      className={cn(
        'fixed top-0 left-0 z-[99999] flex h-full w-full items-center justify-center bg-[rgba(0,0,0,0.8)]',
        className
      )}
    >
      <div className="relative h-1/4 w-1/4">
        <Image alt="pawtree loader" src={loaderImg} style={{ objectFit: 'contain' }} fill={true} />
      </div>
    </div>
  );
};

export default Loader;
